<template>
  <div class="sidebar">
    <div class="sidebar-wrap">
      <div class="searchbox boxshadow1">
        <div class="title">搜索</div>
        <Input class="search" v-model="searchVal" icon="ios-search" type="text" placeholder="输入文章内容" style="width:100%" @on-enter="search" @on-click="search"/>
        <div class="daterange">
          <DatePicker class="dateselect" v-model="dateVal" type="daterange" placement="bottom-start" split-panels clearable :editable="false" placeholder="选择发布日期" style="width:100%" @on-change="dateSearch" format="yyyy-MM-dd"></DatePicker>
        </div>
      </div>
      <div class="classify boxshadow1" v-if="!_.isEmpty(categoryList)">
        <div class="title">标签</div>
        <div class="tags">
          <span v-for="(item, idx) in categoryList" :key="`cate-${idx}`" :class="{active: currentCategory === item.id}" @click.stop.prevent="catetorySearch($event, item.id)">{{item.name}}</span>
        </div>
        <!-- <ul>
          <li v-for="(item, idx) in categoryList" :key="`cate-${idx}`" :class="{active: currentCategory === item.id}">
            <a href="#" @click.stop.prevent="catetorySearch($event, item.id)">{{item.name}}</a>
          </li>
        </ul> -->
      </div>
      <!-- <div class="daterange">
        <div class="title">{{$t('common.date')}}</div>
        <DatePicker class="dateselect" v-model="dateVal" type="daterange" placement="bottom-start" split-panels clearable :editable="false" :placeholder="$t('newsActivity.datePlaceholder')" style="width:100%" @on-change="dateSearch" format="MM/dd/yyyy"></DatePicker>
        <ul>
          <li v-for="(item, idx) in dateList" :key="`date-${idx}`" :class="{active: currentDate === item.id}">
            <a href="#" @click.stop.prevent="dateQuickSearch($event, item.id)">{{item.name}}</a>
          </li>
        </ul>
      </div> -->

      <div class="hotnews boxshadow1">
        <div class="title">热门新闻</div>
        <ul>
          <li v-for="(item, index) in hotNewsList" :key="'related-news-' + index" @click="$router.push({name: 'NewsShow', params: {id: item.id}})">
            <img :src="item.coverImage" v-if="item.coverImage">
            <div class="t1">{{item.title}}</div>
            <div class="t2">{{item.content | removeTag(' ')}}</div>
          </li>
        </ul>
      </div>
      <div class="hotnews suggest boxshadow1">
        <div class="title">专家建议</div>
        <div class="desc">为企业提供一对一咨询，根据企业自身需求特点，提供量身定制的贸易咨询服务及贸易合规管理解决方案，包括关税筹划、预裁定申请、流程梳理、政策解读等。</div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapDataState } = createNamespacedHelpers('data')

export default {
  name: 'NewsListSider',
  props: ['keyword', 'categoryID', 'timeStr'],
  data () {
    return {
      searchVal: '',
      dateVal: '',
      currentCategory: -1,
      currentDate: -1,
      dateList: [
        // {id: -1, name: this.$t('common.allDate')},
        {id: 1, name: this.$t('common.today')},
        {id: 2, name: this.$t('common.yesterday')},
        {id: 3, name: this.$t('common.lastWeek')},
        {id: 4, name: this.$t('common.laseMonth')}
      ]
    }
  },
  computed: {
    hotNewsList () {
      return this.list.slice(0, 6)
    },
    ...mapDataState({
      'list': state => state.relatedNews,
      categoryList (state) {
        let res = [{id: -1, name: this.$t('common.allCate')}]
        res.push(...this._.filter(state.categoryAll, (v) => v.type === 1))
        return res
      }
    })
  },
  created () {
    this.searchVal = this.$route.query.k || ''
  },
  methods: {
    search () {
      this.$emit('update:keyword', this._.trim(this.searchVal) + ' ')
    },
    catetorySearch (event, cid) {
      this.currentCategory = parseInt(cid)
      this.$emit('update:categoryID', parseInt(this._.trim(cid)) || -1)
    },
    dateQuickSearch (event, did) {
      this.currentDate = parseInt(did)
      let startTimestamp = ''
      let endTimestamp = ''
      let d = new Date()
      switch (this.currentDate) {
        case 1:
          startTimestamp = this.getDateRangeStartStr(d)
          endTimestamp = this.getDateRangeEndStr(d)
          break
        case 2:
          d.setDate(d.getDate() - 1)
          startTimestamp = this.getDateRangeStartStr(d)
          endTimestamp = this.getDateRangeEndStr(d)
          break
        case 3:
          // let num = d.getDay() - 1
          let num = d.getDay()
          // d.setDate(d.getDate() - num)
          d.setDate(d.getDate() - num - 7)
          startTimestamp = this.getDateRangeStartStr(d)
          d.setDate(d.getDate() + 6)
          endTimestamp = this.getDateRangeEndStr(d)
          break
        case 4:
          d.setMonth(d.getMonth() - 1)
          d.setDate(1)
          startTimestamp = this.getDateRangeStartStr(d)
          d.setMonth(d.getMonth() + 1)
          d.setDate(d.getDate() - 1)
          endTimestamp = this.getDateRangeEndStr(d)
          break
      }
      this.dateVal = [new Date(startTimestamp), new Date(endTimestamp)]
      this.$emit('update:timeStr', `${startTimestamp}|${endTimestamp}`)
    },
    getDateRangeStartStr (d) {
      d.setHours(0)
      d.setMinutes(0)
      d.setSeconds(0)
      return d.getTime()
    },
    getDateRangeEndStr (d) {
      d.setHours(23)
      d.setMinutes(59)
      d.setSeconds(59)
      return d.getTime()
    },
    dateSearch (dateArr, dateType) {
      this.currentDate = -1
      if (!this._.isEmpty(dateArr) && dateType === 'date') {
        let startTimestamp = (new Date(`${dateArr[0]} 00:00:00`)).getTime()
        let endTimestamp = (new Date(`${dateArr[1]} 23:59:59`)).getTime()
        this.$emit('update:timeStr', `${startTimestamp}|${endTimestamp}`)
      } else {
        this.$emit('update:timeStr', '')
      }
    }
  }
}
</script>
<style scoped>
  .title{
    font-size: 1.6rem;
    color: #333;
    /* background: url("~@/assets/images/home/guide.png") 0 center no-repeat transparent; */
    background-size: 12px;
    /* padding-left: 18px; */
    margin-bottom: 15px;
    position: relative;
    top: 1px;
  }
  .searchbox{
    padding: 12px 16px 18px;
  }
  .searchbox .search{
    margin-bottom: 15px;
  }
  .searchbox >>> .ivu-input,
  .daterange >>> .ivu-input{
    border-color: #999;
    border-radius: 3px;
    padding-left: 12px;
    font-size: 15px;
    border-width: 0.5px;
    color: #333;
  }
  .searchbox >>> .ivu-input:focus,
  .daterange >>> .ivu-input:focus{
    border-color: #0470e3;
  }
  .searchbox >>> .ivu-input::-webkit-input-placeholder,
  .daterange >>> .ivu-input::-webkit-input-placeholder{
    font-size: 14px;
  }
  .searchbox >>> .ivu-input:-moz-placeholder,
  .daterange >>> .ivu-input:-moz-placeholder{
    font-size: 14px;
  }
  .searchbox >>> .ivu-input::-moz-placeholder,
  .daterange >>> .ivu-input::-moz-placeholder{
    font-size: 14px;
  }
  .searchbox >>> .ivu-input:-ms-input-placeholder,
  .daterange >>> .ivu-input:-ms-input-placeholder{
    font-size: 14px;
  }
  .search >>> .ivu-icon,
  .daterange >>> .ivu-icon-ios-close{
    cursor: pointer;
  }
  .daterange >>> .ivu-icon-ios-calendar-outline{
    background: url("~@/assets/images/icons/news/cal.png") center center no-repeat transparent;
    background-size: 12px;
  }
  .search >>> .ivu-icon-ios-search-strong:before,
  .daterange >>> .ivu-icon-ios-calendar-outline:before{
    content: none;
  }
  .daterange >>> .ivu-select-dropdown{
    /*font-size: 11px;*/
    font-size: 13px;
  }
  .daterange >>> .ivu-select-dropdown .ivu-date-picker-cells-header span{
    /*font-size: 11px;*/
    font-size: 13px;
  }
  .hotnews{
    padding: 12px 16px 18px;
  }
  .suggest{
    margin-top: 30px;
  }
  .suggest .title{
    background: url("~@/assets/images/home/light.png") 0 center no-repeat transparent;
    background-size: 16px;
    padding-left: 20px;
  }
  .suggest .desc{
    font-size: 15px;
    line-height: 24px;
  }
  .hotnews ul{
    margin-left: 0;
  }
  .hotnews ul{
    margin-left: 0;
  }
  .hotnews ul li{
    padding: 0 20px;
    margin-bottom: 20px;
    cursor: pointer;
  }
  .hotnews ul li:hover{
    color: #0470e3;
  }
  .hotnews img{
    border-radius: 3px;
    margin-bottom: 8px;
  }
  .hotnews .t1{
    font-size: 15px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    margin-bottom: 8px;
  }
  .hotnews .t2{
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    color: #999;
    font-size: 14px;
  }
  .classify{
    margin: 30px 0;
    padding-bottom: 20px;
    border-bottom: 0.5px solid #E9E9E9;
    padding: 12px 16px 18px;
  }
  .classify .title{
    margin-bottom: 7px;
  }
  .tags{
    margin-left: -5px;
    margin-right: -5px;
  }
  .tags span{
    font-size: 14px;
    display: inline-block;
    margin: 6px 5px;
    cursor: pointer;
  }
  .tags span:hover{
    color: #0470e3;
  }
  .tags span.active{
    color: #0470e3;
  }
  ul{
    margin-top: 15px;
    margin-left: 10px;
  }
  ul li{
    margin-bottom: 10px;
    padding-left: 12px;
  }
  ul li:last-child{
    margin-bottom: 0;
  }
  ul li a{
    color: #999;
    /*font-size: 1.1rem;*/
    font-size: 1.3rem;
  }
  /*.classify ul li a:after{*/
  /*background-color: #999;*/
  /*}*/
  ul li a:hover{
    color: #1F8AFD;
  }
  ul li.active a:after{
    width: 0;
    height: 0;
  }
  ul li.active a{
    color: #1F8AFD;
  }
  ul li.active{
    background: url("~@/assets/images/icons/news/arrow.png") 0 center no-repeat transparent;
    background-size: 7px auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/down/ListSider.vue